import { companyApis } from '@apis/companyApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useCompany = createUseQuery(
  ['/company/'],
  () => () => companyApis.get('/company/', {}).then((r) => r[200]!),
  {
    staleTime: 30000,
  },
);
